// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@kubb/plugin-client/clients/axios";
import type { GetReadingsTarotReadingsGetQueryResponse } from "../models/tarotController/GetReadingsTarotReadingsGet.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";

function getGetReadingsTarotReadingsGetUrl() {
  const res = { method: "GET", url: `/tarot/readings` as const };
  return res;
}

/**
 * @description Get all readings for the current user
 * @summary Get Readings
 * {@link /tarot/readings}
 */
export async function getReadingsTarotReadingsGet(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetReadingsTarotReadingsGetQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: getGetReadingsTarotReadingsGetUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
